import React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import Login from '../views/login/Login'
import NewsSandBox from '../views/sandbox/NewsSandBox'
import { connect } from 'react-redux'

function IndexRouter(props) {
  let loginRedirectUrl = '/login'
  let shouldRedirect = false
  const currentURL = window.location.href;

  //如果當前沒有token 且非login頁面，代表必須轉跳
  if(!props.token && currentURL.indexOf('login') === -1){
    //紀錄當前url，用於登入後轉跳回來
    loginRedirectUrl = `/login?redirect=${encodeURIComponent(currentURL)}`
    shouldRedirect = true;
  }

  //TODO:應該加入如果有token，就到後端verify，可以就轉跳

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/login" component={Login}/>
        <Route path="/" render={()=>{
          //TODO:這裡可以改shouldRedirect && props.token作為判斷
          if(shouldRedirect){//驗證不通過，轉跳到login
            return <Redirect to={loginRedirectUrl}/>
          }else{
            ////有props，也有token的話，進行轉跳
            //TODO:這段要簡化，應先過完整個認證流程，到後段索取驗證資料後，判斷是否轉跳到當前頁面
            return props.token ? <NewsSandBox /> : <Redirect to={loginRedirectUrl}/>
          }
        }}
        ></Route>
      </Switch>
    </BrowserRouter>
  )
}

const mapStateToProps = ({userProfileReducer:{token}}) => {
  return {
    token
  }
}

export default connect(mapStateToProps)(IndexRouter)
